import React, { useState, useEffect } from "react";
import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  FormControl,
} from "@mui/material";
// import Financialreportheader from "./Financialreportheader";
// import Financialreportfooter from "./Financialreportfooter";
// import Financialreporttable from "./FinancialReporttable";
// import { UserListData } from "./UserListData";
// import Financialreportdatepicker from "./Financialreportdatepicker";
// import UserListheader from "./UserListheader";
// import UserListtable from "./UserListtable";
// import Searchbaruserlist from "./Searchbaruserlist";
// import Modaluserlist from "./Modaluserlist";
import Searchbarvideolist from "./Searchbarvideolist";
import Modalvideolist from "./Modalvideolist";
import VideoListtable from "./VideoListtable";
import { VideoListData } from "./VideoListData";
import VideoListheader from "./VideoListheader";
import axios from "axios";
import Nochapter from "../../pages/Nochapter/Nochapter";
import Novideo from "../../pages/Novideo/Novideo";
import Loader from "../../pages/Loader/Loader";

const Videolist = (props) => {
  const { setRender, render, courseList } = props;

  const [course, setCourse] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [pending, setPending] = useState(false);
  const [videosList, setVideosList] = useState([]);

  const [chapterList, setChapterList] = useState([]);

  //////////////////////////// Taking chapters from API
  const getChapterList = async (id) => {
    try {
      const res = await axios.get(
        `api/v1/a34jl49u-q4r67p89/courses/${id}/chapter`
      );
      setChapterList(res.data.chapter);
    } catch (error) {
      console.log("error", error);
    }
  };

  const courseChangeHandler = (e) => {
    setCourse(e.target.value);
    getChapterList(e.target.value._id);
  };

  useEffect(() => {
    axios
      .get(
        `api/v1/a34jl49u-q4r67p89/courses/${course._id}/chapter/${chapter._id}/video`
      )
      .then((res) => setVideosList(res.data.videos))
      .catch((error) => console.log("error ", error));
  }, [render, chapter._id]);

  return (
    <>
      <Box
        sx={{
          background: "#fff",
          marginTop: 3,
          borderRadius: 2,
          border: "1px solid #e0e0ef",
        }}
      >
        {/* <Typography sx={{ background: "#F7F7F7",color:'#000',padding:2,borderBottom: "2px solid #F2F2F2",borderTopLeftRadius:8,borderTopRightRadius:8 }}>Financial Report</Typography> */}
        <Box sx={{ padding: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Searchbarvideolist />

              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ width: "300px", marginBottom: "10px" }}>
                  <FormControl sx={{ width: "300px", marginBottom: 2 }}>
                    <InputLabel id="demo-simple-select-label">
                      Course
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={course}
                      label="Course"
                      placeholder="Course"
                      onChange={courseChangeHandler}
                    >
                      {courseList?.map((course, index) => (
                        <MenuItem key={index} value={course}>
                          {course?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* <InputLabel>Course</InputLabel>

                  <Select
                    fullWidth
                    size="small"
                    value={course}
                    placeholder="Course"
                    onChange={courseChangeHandler}
                    // onClick={handleclick}
                  >
                    {courseList?.map((course, index) => (
                      <MenuItem key={index} value={course}>
                        {course?.name}
                      </MenuItem>
                    ))}
                  </Select> */}
                </Box>

                <Box sx={{ width: "300px", marginBottom: "10px" }}>
                  <FormControl sx={{ width: "300px", marginBottom: 2 }}>
                    <InputLabel id="demo-simple-select-label">
                      Chapter
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={chapter}
                      placeholder="Chapter"
                      onChange={(e) => setChapter(e.target.value)}
                      label="Chapter"
                    >
                      {chapterList?.map((chapter, index) => (
                        <MenuItem key={index} value={chapter}>
                          {chapter?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* <InputLabel>Chapter</InputLabel>

                  <Select
                    fullWidth
                    size="small"
                    value={chapter}
                    placeholder="Chapter"
                    onChange={(e) => setChapter(e.target.value)}
                    // onChange={(e) => setChapter(e.target.value)}
                    // onClick={handleclick}
                  >
                    {chapterList?.map((chapter, index) => (
                      <MenuItem key={index} value={chapter}>
                        {chapter?.name}
                      </MenuItem>
                    ))}
                  </Select> */}
                </Box>
              </Box>
            </Box>

            <Modalvideolist
              courses={courseList}
              chapters={chapterList}
              render={render}
              setRender={setRender}
              course={course}
              setCourse={setCourse}
              chapter={chapter}
              setChapter={setChapter}
            />
          </Box>
          {!pending ? (
            <Box sx={{ overflowY: "hidden", overflowX: "scroll" }}>
              {videosList.length !== 0 ? (
                <>
                  <VideoListheader />
                  {/* <Financialreportdatepicker/> */}
                  {/* {videosList.length !== 0 ? (
       
     ) } */}
                  {videosList.map((item, index) => (
                    <VideoListtable
                      render={render}
                      setRender={setRender}
                      item={item}
                      number={index}
                      key={index}
                    />
                  ))}
                </>
              ) : (
                <Novideo />
              )}
            </Box>
          ) : (
            <Loader />
          )}
        </Box>
      </Box>
    </>
  );
};

export default Videolist;
